import { ThemeProvider } from "@mui/material";
import React from "react";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { mergeTheme } from "./helpers";
import { Container } from "./styles";

export const VariantBase: React.FunctionComponent<{
  children?: React.ReactNode;
  theme: ThemeType;
}> = ({ children, theme }) => (
  <Container>
    <ThemeProvider theme={mergeTheme(theme)}>{children}</ThemeProvider>
  </Container>
);

VariantBase.displayName = "VariantBase";
